import React, { useState, useEffect } from 'react';
import SpinnerLoading from "../loading-spinner/spinerLoading";

const Preloader = (props) => {
    return ( 
        <SpinnerLoading />
     );
}
 
export default Preloader;